// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_63ec0","disabled":"df0d9"};